export enum JobRoleEnum {
  PC = 'PC',
  DPC = 'DPC',
  PLANNER = 'Planner',
  INSPECTOR = 'Inspector',
  AREA_ENGINEER = 'Area Engineer',
  CM = 'CM',
  CONSULTANT = 'Consultant',
}
